import { useContactLensProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const useGetCLLoyaltyPoints = () => {
  const {
    displayPrice: { loyaltyPoints }
  } = useContactLensProductData();
  const { state, selectors } = useCLEcommContext();
  const totalSelectedQuantity = selectors.getEnabledSelectedQuantity(state) || 1;
  return loyaltyPoints && loyaltyPoints * totalSelectedQuantity;
};
export {
  useGetCLLoyaltyPoints
};
//# sourceMappingURL=use-get-cl-loyalty-points.js.map
